import { useMemo } from 'react';

import { FeedbackProps } from '../types';

const useFeedback = (props: Pick<FeedbackProps, 'questions'>) => {
  const { questions } = props;

  // backend will send an array of questions in the order in which they should be asked
  // currently having two questions, one for emoji rating and one for feedback description
  const feedbackQuestionsObject = useMemo(
    () => ({ feedbackRating: questions[0], feedbackDescription: questions[1] }),
    [questions],
  );

  return { feedbackQuestionsObject };
};

export default useFeedback;
